import React from 'react';
import { useLocation } from "react-router-dom";
import { FederatedModule } from "@bfme-technology/spa";
import { getStoredOverrides } from "../../../DeveloperWorkbench/DeveloperWorkbench.utils";
import type { ExpenseManagerRouterMfeProps } from "./ExpenseManagerRouterMfe.types";

export const ExpenseManagerRouterMfe: React.FC<ExpenseManagerRouterMfeProps> = ({ routesLoading, routes }) => {
  const location = useLocation();

  if (routesLoading) {
    return (
      <div className="flex items-center justify-center h-72 text-text-muted text-sm">
        Loading Router...
      </div>
    );
  }

  const route = routes.find((r: any) => r.key === "mfe-expense-router");
  if (!route) {
    return (
      <div className="flex items-center justify-center h-72 text-red-500 text-sm">
        Expense Manager Router configuration not found. Check your
        federatedRoutes.json
      </div>
    );
  }

  const overrides = getStoredOverrides();
  const override = overrides[route.key];

  let resolvedRoute = route;
  if (override) {
    resolvedRoute = {
      mfeType: route.mfeType,
      elementName: route.elementName,
      bootstrapFnName: route.bootstrapFnName,
      unmountFnName: route.unmountFnName,
      scope: route.scope,
      module: route.module,
      scriptUrl: override.scriptUrl || route.scriptUrl,
      cssUrl: override.cssUrl !== undefined ? override.cssUrl : route.cssUrl,
      mfeProps: route.mfeProps || {},
    };
  }

  const { key, ...mfeProps } = resolvedRoute;

  return <FederatedModule {...mfeProps} currentPath={location.pathname} />;
};

export default ExpenseManagerRouterMfe;
